var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-empty',{attrs:{"description":"没有找到此页面"}},[_c('van-button',{staticClass:"bottom-button",attrs:{"round":"","type":""},on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v("返回首页")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }